import React, {useState, useEffect} from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {connectWithCore} from 'framework/hocs';
import REST from 'go/requests/rest';
import {forceJsonResponse, MONO, FLUX} from 'common/utils';

export const SubAppReviewTaskListener = (props) => {
  const {entityId, token, permissions} = props;

  const [done, setDone] = useState(false);

  useEffect(() => {
    let getWorkflowTasksBody = {};
    if (!_.isEmpty(permissions)) {
      getWorkflowTasksBody.candidateGroups = permissions;
    }

    _.assign(getWorkflowTasksBody, {
      includeAssignedTasks: true,
      processVariables: [
        {
          name: 'entityId',
          value: entityId,
          operator: 'eq',
        },
      ],
      taskDefinitionKey: 'reviewSubapplication',
    });

    REST.workflow
      .getAllExternalEligibleTasks(token, '', getWorkflowTasksBody)
      .then((res) => {
        if (res.status === 200) {
          return forceJsonResponse(res, FLUX);
        }
      })
      .then((resJson) => {
        setDone(true);
        if (resJson[0])
          props.saveEntitySessionData('context.workflowTask.task.id', resJson[0].id);
      })
      .catch((error) => console.log(error));
  }, []);

  return <>{null}</>;
};

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    permissions: state.auth.permissions,
  };
};

const connectedSubAppReviewTaskListener = connect(
  mapStateToProps,
  null
)(connectWithCore(SubAppReviewTaskListener));
export default connectedSubAppReviewTaskListener;
